// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pure-table {
  /* Remove spacing between table cells (from Normalize.css) */
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #cbcbcb;
}

.pure-table caption {
  color: #000;
  font:
    italic 85%/1 arial,
    sans-serif;
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  /* inner column border */
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  /* to make this where the title is really long work */
  padding: 0.5em 1em;
  /* cell padding */
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  text-align: left;
  vertical-align: bottom;
}

/*
striping:
even - #fff (white)
odd  - #f2f2f2 (light gray)
*/
.pure-table td {
  background-color: transparent;
}

.pure-table-odd td {
  background-color: #f2f2f2;
}

/* nth-child selector for modern browsers */
.pure-table-striped tr:nth-child(2n-1) td {
  background-color: #f2f2f2;
}

/* BORDERED TABLES */
.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}

/* HORIZONTAL BORDERED TABLES */

.pure-table-horizontal td,
.pure-table-horizontal th {
  border-width: 0 0 1px 0;
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-horizontal tbody > tr:last-child > td {
  border-bottom-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX;;cAEY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;CAIC;AACD;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;;AAE/B;;EAEE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".pure-table {\n  /* Remove spacing between table cells (from Normalize.css) */\n  border-collapse: collapse;\n  border-spacing: 0;\n  empty-cells: show;\n  border: 1px solid #cbcbcb;\n}\n\n.pure-table caption {\n  color: #000;\n  font:\n    italic 85%/1 arial,\n    sans-serif;\n  padding: 1em 0;\n  text-align: center;\n}\n\n.pure-table td,\n.pure-table th {\n  border-left: 1px solid #cbcbcb;\n  /* inner column border */\n  border-width: 0 0 0 1px;\n  font-size: inherit;\n  margin: 0;\n  overflow: visible;\n  /* to make this where the title is really long work */\n  padding: 0.5em 1em;\n  /* cell padding */\n}\n\n.pure-table thead {\n  background-color: #e0e0e0;\n  color: #000;\n  text-align: left;\n  vertical-align: bottom;\n}\n\n/*\nstriping:\neven - #fff (white)\nodd  - #f2f2f2 (light gray)\n*/\n.pure-table td {\n  background-color: transparent;\n}\n\n.pure-table-odd td {\n  background-color: #f2f2f2;\n}\n\n/* nth-child selector for modern browsers */\n.pure-table-striped tr:nth-child(2n-1) td {\n  background-color: #f2f2f2;\n}\n\n/* BORDERED TABLES */\n.pure-table-bordered td {\n  border-bottom: 1px solid #cbcbcb;\n}\n\n.pure-table-bordered tbody > tr:last-child > td {\n  border-bottom-width: 0;\n}\n\n/* HORIZONTAL BORDERED TABLES */\n\n.pure-table-horizontal td,\n.pure-table-horizontal th {\n  border-width: 0 0 1px 0;\n  border-bottom: 1px solid #cbcbcb;\n}\n\n.pure-table-horizontal tbody > tr:last-child > td {\n  border-bottom-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
